export const DEFAULT_DASHBOARD_ID = 'default';
export const MAX_TILES_LIMIT = 8;
export const NAME_MAX_LENGTH = 25;
export const TABNAME_MAX_LENGTH = 40;
